import { render, staticRenderFns } from "./productAnalysis.vue?vue&type=template&id=18d0cabd&scoped=true"
import script from "./productAnalysis.vue?vue&type=script&lang=js"
export * from "./productAnalysis.vue?vue&type=script&lang=js"
import style0 from "./productAnalysis.vue?vue&type=style&index=0&id=18d0cabd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0cabd",
  null
  
)

export default component.exports